import React from "react";
import { CreateEditPaymentMethodContext } from "./context";

export const useCreateEditPaymentMethodContextProvider = () => {
  const context = React.useContext(CreateEditPaymentMethodContext);
  return context;
};
